import { useCallback } from "react";
import { CopyButton, Transition, Button } from "@mantine/core";
import { CloseIcon } from "@form/components/common/icons";

import type { FC } from "react";

const ShareModal: FC<{
  link?: string;
  opened: boolean;
  setOpened: (opened: boolean) => void;
}> = ({ opened, setOpened, link }) => {
  const close = useCallback(() => {
    setOpened(false);
  }, []);

  return (
    <Transition
      mounted={opened}
      transition="slide-up"
      duration={200}
      timingFunction="ease"
    >
      {(styles) => (
        <div
          className={`bg-white shadow-card rounded-lg p-4 text-gray_58 relative z-[21]`}
          style={{
            ...styles,
          }}
        >
          <div className="flex justify-end">
            <CloseIcon
              className="fill-primary action"
              onClick={close}
            ></CloseIcon>
          </div>
          <div className="text-bodyS font-bold">Share via link</div>
          <div className="flex items-center mt-4 mb-3">
            <input
              value={link}
              className="w-full flex-1 outline-none p-1 h-[30px] bg-gray_f9 text-body text-ellipsis overflow-hidden whitespace-nowrap"
            />
            <div className="flex ml-3 flex-shrink-0" data-track="copy_link">
              <CopyButton value={link || ""}>
                {({ copied, copy }) => (
                  <Button
                    variant="filled"
                    size="xs"
                    onClick={() => {
                      copy();
                      setTimeout(() => {
                        setOpened(false);
                      }, 250);
                    }}
                  >
                    {" "}
                    {copied ? "Copied 🎉" : "Copy Link"}
                  </Button>
                )}
              </CopyButton>
            </div>
          </div>
        </div>
      )}
    </Transition>
  );
};

export default ShareModal;
